import { useDispatch, useSelector } from 'react-redux';
import FJPhotoRemoveBgRight from '../view/FJPhotoRemoveBgRight';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon';
import FJActionPhotoBgRemover from '../../../../redux/action/FJActionPhotoBgRemover';
import { useCallback } from 'react';
import { useMemo } from 'react';
import FJConstant from '../../../../constants/FJConstant';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJPhotoRemoveBgRightContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const curMenuIndex = useSelector(state => state.photoBgRemover.curMenuIndex);
    const autoBgImageDataList = useSelector(state => state.photoBgRemover.autoBgImageDataList);
    const brushEditStatus = useSelector(state => state.brushEditCommon.brushEditStatus);
    const hasEditImage = useSelector(state => {
        const editImage = state.brushEditCommon.editImage;
        return editImage && editImage.src && editImage.src !== '';
    });
    const displayUploadFile = useMemo(() => {
        return curMenuIndex === 0 && autoBgImageDataList.some(item => item.taskStatus !== FJConstant.DEFAULT);
    }, [curMenuIndex, autoBgImageDataList]);

    const uploadFile = useCallback(
        files => {
            if (displayUploadFile) return;

            if (curMenuIndex === 1) {
                dispatch(FJActionPhotoBgRemover.uploadCustomBgImageFile(files));
            } else {
                dispatch(FJActionPhotoBgRemover.uploadAutoBgImageFile(files));
            }
        },
        [dispatch, curMenuIndex, displayUploadFile],
    );

    const _setIsDraggingFile = useCallback(
        value => {
            if (displayUploadFile) return;
            dispatch(setSliceIsDraggingFileAction(value));
        },
        [dispatch, displayUploadFile],
    );

    const isShowThumbnail = useMemo(() => {
        return curMenuIndex === 0 && autoBgImageDataList.length > 1;
    }, [curMenuIndex, autoBgImageDataList]);

    const initImagePadding = useMemo(() => {
        return isShowThumbnail ? { width: 40 * 2, height: 227 } : undefined;
    }, [isShowThumbnail]);

    const offsetTop = useMemo(() => {
        return isShowThumbnail ? -32 : undefined;
    }, [isShowThumbnail]);

    return (
        <FJPhotoRemoveBgRight
            multipleUpload={curMenuIndex === 0}
            uploadFile={uploadFile}
            setIsDraggingFile={_setIsDraggingFile}
            initImagePadding={initImagePadding}
            offsetTop={offsetTop}
            hasEditImage={hasEditImage}
            disableDragUpload={displayUploadFile || brushEditStatus !== FJConstant.START}
        />
    );
};

export default FJPhotoRemoveBgRightContainer;
